export const SUBMIT_EMAIL = "SUBMIT_EMAIL";
export const SUBMIT_COMMUNICATION_METHOD = "SUBMIT_COMMUNICATION_METHOD";
export const SELECT_COMMUNICATION_METHOD = "SELECT_COMMUNICATION_METHOD";
export const ADD_USER_ID = "ADD_USER_ID";
export const SECURITY_QUE_NOT_AVAILABLE = "SECURITY_QUE_NOT_AVAILABLE";

export interface IForgotPasswordState {
    email?: string;
    communicationMethodList?: communicationMethod[];
    selectedMethod?: string;
    userId?: string;
    isSecurityQueNotAvailable?: boolean;
}

export interface communicationMethod {
    methodType?: string;
    recepientAddress?: string;
}
export interface isSecurityQueNotAvailable {
    type: "SECURITY_QUE_NOT_AVAILABLE";
    isSecurityQueNotAvailable: boolean;
}
export interface SubmitEmailAction {
    type: "SUBMIT_EMAIL";
    email: string;
}
export interface AddUserIdAction {
    type: "ADD_USER_ID";
    userId: string;
}
export interface SubmitCommunicationMethodAction {
    type: "SUBMIT_COMMUNICATION_METHOD";
    communicationMethodList: communicationMethod[];
}
export interface SelectCommunicationMethodAction {
    type: "SELECT_COMMUNICATION_METHOD";
    selectedMethod: string;
}

export type KnownAction = SubmitEmailAction | SubmitCommunicationMethodAction | SelectCommunicationMethodAction | AddUserIdAction | isSecurityQueNotAvailable;
